<template>
    <div class="wrap">
        <div class="container lnb"  style="position: relative">
            <div class="contents_wrap" style="height: 100%;">
                <div class="contents">
                    <div class="tab">
                        <div class="tab_wrap">
                            <div class="t_txt" :class="{'active' : tabIdx === 1}" @click="changeTab(1)">기본정보</div>
                            <div class="t_txt" :class="{'active' : tabIdx === 2}" @click="changeTab(2)">룩북 관리</div>
                            <div class="t_txt" :class="{'active' : tabIdx === 3}" @click="changeTab(3)">상품관리</div>
                            <div class="t_txt" :class="{'active' : tabIdx === 4}" @click="changeTab(4)">리뷰</div>
                            <div class="t_txt" :class="{'active' : tabIdx === 5}" @click="changeTab(5)">주문내역</div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tab_content" v-show="tabIdx === 1">
                        <div class="title">
                            기본설정
                            <div class="clear"></div>
                        </div>
                        <brand-write-component :brandType="'updateBrand'" :brandKey="brandKey"></brand-write-component>
                        <div class="pt20" style="text-align: center;">
                            <el-button @click="submitForm()" type="primary">저장</el-button>
                            <el-button @click="deleteForm()" type="danger">삭제</el-button>
                        </div>
                    </div>
                    <div v-if="tabIdx === 2" class="tab_content">
                        <banner-component :brandKey="brandKey"></banner-component>
                    </div>
                    <div v-if="tabIdx === 3" class="tab_content">
                        <div class="title">
                            상품 목록
                            <el-button class="title_btn" @click="$modal.show('item-select-modal',{defaultFilter:noBrandFilter})" type="primary">상품 등록</el-button>
                            <div class="clear"></div>
                        </div>
                        <item-list-new-component :itemType="'brandItem'" :brandKey="brandKey"></item-list-new-component>
                        <!-- <elastic-list-component  :elasticType="'brandItem'" :defaultFilter="defaultFilter" :brandKey="brandKey" ></elastic-list-component> -->
                    </div>
                    <div v-if="tabIdx === 4" class="tab_content">
                        <review-list-component :reviewType="'brandList'" :brandKey="brandKey"></review-list-component>
                    </div>
                    <div v-if="tabIdx === 5" class="tab_content">
                        <order-list-component :orderType="'brandOrderHistory'" :brandKey="brandKey"></order-list-component>
                    </div>


                </div>
            </div>
            <page-footer></page-footer>
        </div>
        <item-select-modal></item-select-modal>
    </div>
</template>

<script>
import BrandWriteComponent from "@/components/brand/BrandWriteComponent";
import ElasticListComponent from "@/components/elastic/ElasticListComponent";
import ItemSelectModal from "@/components/modal/ItemSelectModal.vue";
import EventBus from "@/mixins/event-bus";
import OrderListComponent from "@/components/order/OrderListComponent";
import BannerComponent from "@/components/banner/BannerComponent";
import ReviewListComponent from "@/components/review/ReviewListComponent.vue";
import ItemListNewComponent from "@/components/item/ItemListNewComponent.vue";
import util from "../../mixins/util";
export default {
    name: "BrandDetail",
    mixins: [],
    components: {BrandWriteComponent,ElasticListComponent,ItemSelectModal,OrderListComponent,BannerComponent,ReviewListComponent,ItemListNewComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            brandData:{},
            brandKey: this.$route.params.b_idx,
            tabIdx: 1,
            defaultFilter : {
                query: {
                    bool: {
                        must: [
                            {match: {"i_is_delete": 0}},
                            {match: {"b_idx":this.$route.params.b_idx }},
                        ]
                    }
                }
            },
            noBrandFilter: {
                query: {
                    bool: {
                        must: [
                            {match: {"i_is_delete": 0}},
                        ],
                        must_not: {
                          "exists": {
                            "field": "b_idx"
                          }
                        }
                    },
                }
            },
        }
    },
    beforeRouterEnter() {
    },
    created() {
        EventBus.$on("getBrandData",this.getBrandData)
        if(!util.isEmpty(this.$route.query.tab) && !isNaN(this.$route.query.tab)) {
            this.tabIdx = Number(this.$route.query.tab);
        }
    },
    mounted() {

    },
    beforeDestroy() {
        EventBus.$off("getBrandData")
    },
    destroyed() {
    },
    computed: {},
    methods: {
        submitForm() {
            EventBus.$emit('writeBrand');
        },
        deleteForm() {
            EventBus.$emit('deleteBrand');
        },
        changeTab(idx) {
            this.tabIdx = idx;
            this.$router.replace(`${this.$route.path}?tab=${idx}`);
        },
        getBrandData(brandData){
            this.brandData = brandData
        },
        isBrandShow(){
            return this.brandData.hasOwnProperty('b_lookbook_display') && this.brandData.b_lookbook_display == 1
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
